import React from 'react';
import { CircularProgress, Stack } from '@mui/material';

import { Props } from './props';

const SpinnerView: React.FC<Props> = (props) => {
  const { spinnerProps, ...rest } = props;
  return (
    <Stack
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        py: '10rem',
      }}
      {...rest}
    >
      <CircularProgress color="inherit" {...spinnerProps} />
    </Stack>
  );
};
export const Spinner = SpinnerView;
export default SpinnerView;
